<div class="container">
    <div *ngIf="isLoading" class="row center">
        <div class="spinner-border text-danger" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <div *ngIf="!isLoading" class="row">
        <div class="col-lg-12 col-md-12 col-xs-12">
            <div class="col-md-6 col-xs-6 mgb-10">
                <h2>Server Status</h2>
            </div>
            <div class="col-md-3 col-xs-3 mgb-10">
                <h4 style="margin-top: 35px;color:crimson;">Central Connection {{ centralConn }}</h4>
            </div>
            <div class="col-md-3 col-xs-3 mgb-10">
                <h4 style="margin-top: 35px;color:#3c763d;">Score Connection {{ scoreConn }}</h4>
            </div>
            <div class="col-md-12 col-xs-12">
                <div class="table-responsive">
                    <div class="col-md-12 col-xs-9 mgb-10" *ngFor="let key of process; let i = index">
                        <h3># {{ key.type }}</h3>
                        <br>
                        <table class="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>Total Cpu Usage</th>
                                    <th>Total Memory</th>
                                    <th>Used Memory</th>
                                    <th>Available Memory</th>
                                    <th>Used Percentage</th>
                                    <th>Network Bytes Received</th>
                                    <th>Network Bytes Sent</th>
                                    <th>Last Restart Time</th>
                                    <th>Total Core</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ key.data.Total_Cpu_Usage }}</td>
                                    <td>{{ key.data.Total_Memory }}</td>
                                    <td>{{ key.data.Used_Memory }}</td>
                                    <td>{{ key.data.Available_Memory }}</td>
                                    <td>{{ key.data.Available_Percentage }}</td>
                                    <td>{{ key.data.Network_bytes_received }}</td>
                                    <td>{{ key.data.Network_bytes_sent }}</td>
                                    <td>{{ key.data.Server_Boot_Time }}</td>
                                    <td>{{ key.data.Total_Cores }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="col-md-1" *ngFor="let cores of key.data.Usage_Per_Core; let j = index">
                            <b>{{ j+1 }}. {{ cores[j] }}</b>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>